import { styled } from '@mui/material';

import { AiReviewHeader } from '../AiReviewHeader';
import { useLoopContext } from '../../hooks/useLoopContext';
import { SingleAiResponseContext } from '../SingleAiResponse/context/SingleAiResponseContext';

const StyledNextAiReviewContainer = styled('li')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  border: '1px solid #e8e8e8',
  borderRadius: 8,
  backgroundColor: '#fff',
  overflow: 'hidden',
  position: 'relative',
  padding: `${theme.spacing(4)}`,
}));

export type NextAiResponseLoadingProps = {
  stepNumber: number;
};

export const NextAiResponseLoading = ({
  stepNumber,
}: NextAiResponseLoadingProps) => {
  const loop = useLoopContext();

  return (
    <SingleAiResponseContext.Provider
      value={{
        analysing: true,
        stepNumber: loop
          ? loop.unaffectedMessagesCount + stepNumber
          : stepNumber,
      }}
    >
      <StyledNextAiReviewContainer>
        <AiReviewHeader />
      </StyledNextAiReviewContainer>
    </SingleAiResponseContext.Provider>
  );
};
